<template>
	<div id='logo-container'>
		<a href="https://www.id-photo-verify.com/edu/admin/#/"><img src="../assets/logo.png"></a>
	</div>
</template>

<script>
export default {
	name:'logo',
	data() {
		return {
			
		}
	}
}
</script>

<style scoped="scoped">
	#logo-container{
		height: 66px;
		padding: 13px 0 12px 35px;
		box-sizing: border-box;
		width: 100%;
	}
	#logo-container img{
		height: 41px;
	}
</style>
